<script setup>
import Exporter from "vue-chartjs-exporter";
import {ref} from "vue";

const props = defineProps({

  /**
   * A string that is typically an identifier for the chart to be printed. It is firstly
   * passed in the `KpiAnalysis.vue` or `PsiAnalysis.vue`, and it can be something like
   * `bar5` or `graph5`. This identifier is then used with a `getElementById()` to find
   * the corresponding graph.
   */
  id: {
    type: String,
    required: true
  }
});

const invisibleClass = ref('');

function printChart(id) {
  let graphical = document.getElementById(id);
  const exp = new Exporter([graphical]);
  exp.export_pdf().then((pdf) => pdf.save("charts.pdf"));
}

function exportPdfFile() {
  invisibleClass.value = 'd-none';

  setTimeout(() => {
    printChart(props.id);
    invisibleClass.value = '';
  }, 300);
}

</script>

<template>
  <v-tooltip contained location="left" text="Download the chart">
    <template v-slot:activator="{ props }">
      <v-btn
          :class="invisibleClass"
          v-bind="props"
          @click="exportPdfFile"
          rounded
          flat
          size="small"
          color="blue-darken-4"
          icon="fa fa-download"
      />
    </template>
  </v-tooltip>
</template>
